import { createContext } from 'react';
import { workflowsAppDefaults } from 'automation-ui-source-apps/config/defaults/WorkflowsAppDefaults';
import { jsx as _jsx } from "react/jsx-runtime";
export const AppConfigContext = /*#__PURE__*/createContext({
  config: workflowsAppDefaults,
  isEmbedded: false
});
export const AppConfigConsumer = AppConfigContext.Consumer;
export const AppConfigProvider = AppConfigContext.Provider;
export function wireAppConfigConsumer(WrappedComponent) {
  return props => /*#__PURE__*/_jsx(AppConfigConsumer, {
    children: appConfigContext => /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      appConfigContext: appConfigContext
    }))
  });
}